import { axiosInstance } from './interceptor';
/**
 * Generic Method to make an axios GET method 
 * @param {*} path
 */

export const API_FETCH = async (path:string) => {
    try {
        const response = await axiosInstance.get(path);
        return Promise.resolve(response.data);
    } catch (error: any) {
        return Promise.reject(error);
    }
};

/**
 * Generic Method to make an axios POST method 
 * @param {*} path
 * @param {*} payload
 */

export const API_POST = async (path:string, payload:any) => {
    try {
        const response = await axiosInstance.post(path, payload);
        return Promise.resolve(response.data);
    } catch (error: any) {
        return Promise.reject(error);
    }
};

/**
 * Generic Method to make an axios PUT method
 * @param {*} path
 * @param {*} payload
 */

export const API_UPDATE = async (path:string, payload:any) => {
    try {
        const response = await axiosInstance.put(path, payload);
        return Promise.resolve(response.data);
    } catch (error: any) {
        return Promise.reject(error.response);
    }
};

/**
 * Generic Method to make an axios DELETE method
 * @param {*} path
 */

export const API_DELETE = async (path:string) => {
    try {
        const response = await axiosInstance.delete(path);
        return Promise.resolve(response.data);
    } catch (error: any) {
        return Promise.reject(error.response);
    }
};
